import React from "react";
import { WidgetInputProps, WidgetInputRadioList } from "../../types";
import { WidgetInputLabel } from "@fidget/common/components/chat/widgetInputLabel/widgetInputLabel";
import styles from "../styles.css";
import { WidgetCheckboxInput } from "@fidget/common/components/inputs/widgetCheckboxInput/widgetCheckboxInput";

interface Props extends WidgetInputProps {
  input: WidgetInputRadioList;
}
export const RadioListInput = ({ input, formId, isSubmitted, onChange, userAnswers }: Props) => {
  return (
    <div>
      <WidgetInputLabel text={input.displayName} />
      <div className={styles["options-checkboxes"]}>
        {input.options.map((o) => (
          <WidgetCheckboxInput
            radioStyle
            id={formId + o.value}
            key={o.value}
            onChange={(checked) => checked && onChange({ inputName: input.name, value: o.value })}
            checked={userAnswers[input.name]?.value === o.value}
            label={o.displayName}
            colorSchema="primary"
            disabled={isSubmitted}
          />
        ))}
      </div>
    </div>
  );
};
